import React, { Component } from 'react'
import { defineMessages, FormattedMessage, injectIntl } from "react-intl";
import QuestionConversationContent from "../question-conversation/questionconversationcontent.jsx";
import $ from 'jquery'
import ActionButton from "../common/button/actionbutton.component.jsx";
import ConfirmButton from "../common/button/confirmbutton.component.jsx";
import { AppContext } from '@lightspeed-invoicing/core-client/frontend'
import Icon from "../common/icon/icon.component.jsx";
import GlobalHelper from '../common/GlobalHelper.jsx'
import LoadingSpinner from "../common/spinner/loading.component.jsx";
import './questionconversation.scss'
import QuestionConversationPanel from "./questionconversationpanel.jsx";
import { Link } from "react-router-dom";
import ConversationStatusButtonSelectorComponent
    from "../inbox/components/ConversationStatusButtonSelectorComponent.tsx";
import { TYPE_EMAIL, TYPE_SMS } from "../state/conversation/ConversationThreadTypes";
import 'react-phone-number-input/style.css'
import PhoneInput from 'react-phone-number-input'
import Checkbox from "../common/checkbox/checkbox.component";
import SmsInput from "./components/SmsInput";

const messages = defineMessages({
    "question_placeholder": {
        id: 'question.conversation.modal.textarea_placeholder',
        defaultMessage: 'Type your reply here...',
    },
    "phone_number": {
        id: 'question.conversation.modal.phone_number',
        defaultMessage: 'Phone Number',
    },
    "invoices": {
        id: 'question.conversation.modal.invoice',
        defaultMessage: 'invoice',
    },
    "quotes": {
        id: 'question.conversation.modal.quote',
        defaultMessage: 'quote',
    },
    "orders": {
        id: 'question.conversation.modal.order',
        defaultMessage: 'order',
    }
})

class QuestionConversationChatModal extends Component {

    constructor(props, context) {
        super(props, context)
        this.state = {
            modalId: this.props.modalId || 'conversation-modal',
            project: this.props.project || null,
            session: this.props.session || null,
            selectedThread: this.props.selectedThread,
            threadType: this.props.threadType || "",
            selectedProducts: [],
            redirect: '',
            questionText: '',
            customerPhoneNumber: this.props.customerPhoneNumber || "",
            questionSubmitted: false,
            invoiceId: this.props.invoiceId || '',
            orderId: this.props.orderId || '',
            quoteId: this.props.quoteId || '',
            loadingConversation: false,
            statusLoading: false,
            fromEmail: [],
            includeProposalLink: false,
            imageIds: [],
            showImageInputModal: false,
            smsInputReRenderKey: 0
        }
        this.closeModal = this.closeModal.bind(this)
        this.handleCloseModal = this.handleCloseModal.bind(this)
        this.handleChange = this.handleChange.bind(this)
        this.handleSubmit = this.handleSubmit.bind(this)
        this.createQuote = this.createQuote.bind(this)
        this.handleConversationStatusChange = this.handleConversationStatusChange.bind(this)
        this.handleChangePhoneNumber = this.handleChangePhoneNumber.bind(this)
        this.routine = null
        this.handleImageChange = this.handleImageChange.bind(this)
        this.getSelectedThreadIndex = this.getSelectedThreadIndex.bind(this)
    }

    componentDidMount() {
        this.setState({
            loadingConversation: true,
        })
        $('#' + this.state.modalId).modal('show')
        this.reloadConversation(this.props.projectId, () => {
            this.scrollToTheEnd()
        })
        this.routine = setInterval(() => {
            const currentNumberOfMessage = this.getNumberOfMessage()
            this.reloadConversation(this.props.projectId, () => {
                if (currentNumberOfMessage !== this.getNumberOfMessage()) {
                    this.scrollToTheEnd()
                }
            })
        }, 5000)
    }

    componentWillUnmount() {
        clearInterval(this.routine)
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            project: nextProps.project || null,
            selectedThread: nextProps.selectedThread || 0,
            invoiceId: nextProps.invoiceId || '',
            orderId: nextProps.orderId || '',
            quoteId: nextProps.quoteId || '',
        })
    }

    reloadConversation(projectId, callback) {
        if (!projectId) {
            projectId = this.state.project.id
        }
        if (!callback) {
            callback = () => { }
        }
        AppContext.getApiClient().get(`/projects/${projectId}`).then(r => {
            let tmpSelectedThread = GlobalHelper.getConversationThreadIndex(r.attributes.conversationThreads, TYPE_EMAIL) || 0
            this.setState({
                project: r,
                loadingConversation: false,
                sessionId: r.attributes.sessionId,
                selectedThread: tmpSelectedThread,
            }, callback)
        })
    }

    scrollToTheEnd() {
        setTimeout(() => {
            const div = document.getElementById('questionConversationContentModal')
            div.scrollTop = div.scrollHeight - div.clientHeight
        }, 200)
    }

    getNumberOfMessage() {
        if (!this.state.project) {
            return 0
        }
        const conversationThreads = this.state.project.attributes.conversationThreads
        const conversation = (conversationThreads && conversationThreads.length > 0 && this.state.selectedThread !== -1) ?
            conversationThreads[this.state.selectedThread] : { messages: [] }
        return conversation.messages.length
    }

    closeModal(quoteId) {
        $('#' + this.state.modalId).modal('hide')
        if (this.props.onClose) {
            this.props.onClose(quoteId)
        }
    }

    handleCloseModal(event) {
        event.preventDefault()
        this.closeModal()
    }

    handleChangePhoneNumber(phoneNumber) {
        this.setState({ customerPhoneNumber: phoneNumber });
    }

    handleChange(event) {
        this.setState({ questionText: event.target.value });
    }

    handleSubmit(event) {
        event?.preventDefault()
        this.setState({
            loading: true,
        })

        let content = this.state.questionText
        if (this.state.includeProposalLink) {
            content = `${content}${this.props.publicLink ? `\n${this.props.publicLink}` : ''}`
        }
        const selectedThread = this.state.project.attributes.conversationThreads.length > 0 &&
            this.getSelectedThreadIndex() !== -1 ? this.state.project.attributes.conversationThreads[this.getSelectedThreadIndex()].id : ''
        let data = {
            fromEmail: this.state.fromEmail,
            sender: "seller",
            content: content,
            sellerId: AppContext.getUserLoggedIn().id,
            customerId: this.state.project.attributes.contactId,
            customerPhoneNumber: this.state.customerPhoneNumber,
            conversationThreadType: this.state.threadType,
            accountId: this.state.project.attributes.accountId,
            conversationThreadId: selectedThread,
            imageIds: this.state.imageIds
        }

        if (this.state.quoteId) {
            data.quoteReferenceId = this.state.quoteId
        } else if (this.state.invoiceId) {
            data.invoiceReferenceId = this.state.invoiceId
        } else if (this.state.orderId) {
            data.orderReferenceId = this.state.orderId
        }

        AppContext.getApiClient().post(`/projects/${this.state.project.id}/messages`, data).then(res => {
            this.setState({
                showImageInputModal: false,
                loading: false,
            })
            if (!res.error) {
                this.reloadConversation(this.state.project.id, () => {
                    this.scrollToTheEnd()
                })

                this.setState({
                    questionSubmitted: true,
                    questionText: '',
                    smsInputReRenderKey: this.state.smsInputReRenderKey + 1,
                    imageIds: [],
                    includeProposalLink: false
                })
            }
        })
    }

    createQuote(e) {
        e.preventDefault()
        AppContext.getApiClient().post('/quotes', {
            projectId: this.state.project.id,
            productRows: this.state.selectedProducts.map(p => {
                return {
                    measure: p.quantity,
                    additionalMeasure: "0",
                    billingMethod: 'one-time',
                    status: 'active',
                    productId: p.id,
                    taxable: true,
                    hidePrice: false
                }
            })
        }).then(res => {
            this.closeModal(res.id)
        })
    }

    handleConversationStatusChange(status) {
        this.setState({
            statusLoading: true,
        })
        AppContext.getApiClient().patch(`/projects/${this.state.project.id}`, {
            conversationStatus: status
        }).then(res => {
            this.setState({
                statusLoading: false,
                project: res,
            })
        })
    }

    handleImageChange(imageIds) {
        this.setState({
            imageIds: imageIds
        })
    }

    getSelectedThreadIndex() {
        const threadType = this.state.threadType || TYPE_EMAIL;
        return GlobalHelper.getConversationThreadIndex(this.state.project.attributes.conversationThreads, threadType)
    }


    render() {
        const disableSubmit = (!this.state.questionText && this.state.imageIds.length === 0) ||
            (this.props.threadType === TYPE_SMS && !GlobalHelper.isTwilioNumberValid(this.state.customerPhoneNumber))

        return <div className="modal fade"
            id={this.state.modalId}
            role="dialog"
            aria-labelledby="conversationModalTitle"
            data-backdrop="static"
            data-keyboard="false"
        >
            {this.state.redirect}
            <div className={"modal-dialog h-100 " + (this.props.displaySessionInfo ? 'modal-xl' : 'modal-md')} role="document">
                <div className="modal-content" style={{ height: '90%' }}>
                    <div className="modal-header p-3">
                        <div className="modal-title mb-0 pb-0 border-0" id="conversationModalTitle">

                            {!this.props.displaySessionInfo && this.state.threadType !== TYPE_SMS && <div className={"h5 mb-0"}>
                                <FormattedMessage
                                    id="question.conversation.modal.questions_and_answers_title"
                                    defaultMessage="Questions and answers"
                                />
                            </div>}

                            {!this.props.displaySessionInfo && this.state.threadType === TYPE_SMS && <div className={"h5 mb-0"}>
                                <FormattedMessage
                                    id="send_sms.modal.modal.title"
                                    defaultMessage="Send an SMS"
                                />
                            </div>}

                            {!this.props.displaySessionInfo && <h6 className="mb-0 text-left"> {this.state.project ? this.state.project.attributes.contact.attributes.name : ''} </h6>}
                            {this.props.displaySessionInfo && this.state.project &&
                                <h5 className={'mb-0'}>
                                    <Link to={'/contacts/' + this.state.project.attributes.contact.id + '/details'}>
                                        <Icon value={'user'} className={'mr-2'} />
                                        {this.state.project.attributes.contact.attributes.name}
                                    </Link>
                                    <small className={'ml-2'}>
                                        {this.state.project.attributes.contact.attributes.email}
                                    </small>
                                </h5>}

                        </div>
                        <button type="button" className="close" onClick={this.handleCloseModal} aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>

                    <div id={'questionConversationContentModal'} className="modal-body d-flex" style={{ overflow: 'scroll', height: '100%' }}>
                        <div className={this.props.displaySessionInfo ? 'w-50' : 'w-100'}>
                            {!this.state.loadingConversation ?
                                <QuestionConversationContent project={this.state.project} selectedThread={this.getSelectedThreadIndex()} isCustomer={false} /> :
                                <div className="d-flex justify-content-center align-items-center h-100">
                                    <LoadingSpinner />
                                </div>
                            }
                        </div>

                        {this.state.sessionId && this.props.displaySessionInfo && <div className={'w-50 px-4 pb-4 border-left'}>
                            <QuestionConversationPanel sessionId={this.state.sessionId} onChange={products => {
                                this.setState({ selectedProducts: products })
                            }} closeModal={this.closeModal} />
                        </div>}

                    </div>
                    <div className="modal-footer d-flex justify-content-end pt-3 px-4">
                        <div className="w-100">
                            <form onSubmit={this.handleSubmit}>
                                {this.props.threadType && this.props.threadType === TYPE_SMS &&
                                    <PhoneInput
                                        className={'mb-2'}
                                        value={this.state.customerPhoneNumber}
                                        onChange={this.handleChangePhoneNumber}
                                        placeholder={
                                            this.props.intl.formatMessage(messages["phone_number"])
                                        }
                                    />
                                }

                                <SmsInput
                                    key={this.state.smsInputReRenderKey}
                                    threadType={this.props.threadType}
                                    accountId={this.state.project?.attributes.accountId}
                                    images={this.state.imageIds}
                                    content={this.state.content}
                                    onImageCallback={this.handleImageChange}
                                    onContentCallback={this.handleChange}
                                />

                                {this.state.threadType === TYPE_SMS && this.state.project && !GlobalHelper.isTwilioNumberValid(this.state.customerPhoneNumber) &&
                                    <div className="text-danger mb-2 p-2 text-right">
                                        <small>
                                            <Icon value={"exclamation"} className={"mr-1"} />

                                            <FormattedMessage
                                                id="question.conversation.modal.contact_invalid_phone_number"
                                                defaultMessage="This contact's phone number is invalid. They won't receive an sms when you reply."
                                            />
                                        </small>
                                    </div>
                                }

                                {this.state.threadType !== TYPE_SMS && this.state.project && !GlobalHelper.validateEmail(this.state.project.attributes.contact.attributes.email) &&
                                    <div className="text-danger mb-2 p-2 text-right">
                                        <small>
                                            <Icon value={"exclamation"} className={"mr-1"} />

                                            <FormattedMessage
                                                id="question.conversation.modal.contact_invalid_email"
                                                defaultMessage="This contact's email doesn't exist or is invalid. They won't receive an email notification when you reply."
                                            />
                                        </small>
                                    </div>
                                }

                                {this.state.threadType === TYPE_SMS &&
                                    <div className="mb-2 mt-2 text-left" >
                                        <Checkbox
                                            checked={this.state.includeProposalLink}
                                            onChange={include => {
                                                this.setState({
                                                    includeProposalLink: include
                                                })
                                            }}
                                        />

                                        <FormattedMessage
                                            id="question.conversation.modal.include_proposal_link"
                                            defaultMessage="Include the link to the {documentType} in your message"
                                            values={{
                                                documentType: this.props.intl.formatMessage(messages[this.state.project.attributes.documentType])
                                            }}
                                        />
                                    </div>
                                }

                                <div className="d-flex justify-content-end mt-3">
                                    <ConfirmButton
                                        className={'btn btn-secondary px-3 py-2 mr-2'}
                                        message={
                                            <FormattedMessage
                                                id="question.conversation.modal.close_lose_text_warning"
                                                defaultMessage="Are you sure you don't want to send your message ? You will lose it if you close this modal."
                                            />
                                        }
                                        style={{
                                            fontSize: '1rem',
                                            fontWeight: 'bold',
                                            height: '12%',
                                        }}
                                        ignoreConfirm={this.state.questionText.length === 0}
                                        onClick={this.handleCloseModal}
                                    >
                                        <FormattedMessage
                                            id="question.conversation.close"
                                            defaultMessage="Close"
                                        />
                                    </ConfirmButton>

                                    {this.state.project && this.props.displaySessionInfo && <ConversationStatusButtonSelectorComponent
                                        status={this.state.project.attributes.conversationStatus}
                                        onChange={this.handleConversationStatusChange}
                                        isLoading={this.state.statusLoading}
                                    />}

                                    {this.state.sessionId && this.props.displaySessionInfo &&
                                        <ActionButton className={'btn btn-success px-3 py-2 mr-2'} onClick={this.createQuote}>
                                            <Icon value={'quote'} className={'mr-1'} />
                                            <FormattedMessage
                                                id="question.panel.create_quote_btn"
                                                defaultMessage="{nbItems, plural, =0 {Create a new quote} one {Create a new quote with one item} other {Create a new quote with # items}}"
                                                values={{
                                                    nbItems: this.state.selectedProducts.map(p => parseInt(p.quantity)).reduce((prev, curr) => prev + curr, 0)
                                                }}
                                            />
                                        </ActionButton>}

                                    <div>
                                        <ActionButton
                                            type="button"
                                            className="btn btn-primary px-3 py-2 approve-btn"
                                            style={{
                                                fontSize: '1rem',
                                                fontWeight: 'bold',
                                            }}
                                            disabled={disableSubmit}
                                            isLoading={this.state.loading}
                                            onClick={this.handleSubmit}
                                        >
                                            <Icon value={'paper-plane'} className={'mr-1'} />
                                            <FormattedMessage
                                                id="question.conversation.send_message"
                                                defaultMessage="Send your message"
                                            />
                                        </ActionButton>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }


}

export default injectIntl(QuestionConversationChatModal)





// WEBPACK FOOTER //
// ./src/question-conversation/questionconversationchatmodal.jsx